/**
 * @generated SignedSource<<ee5b117fd4085e8eb913552f18369442>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CrmListTypeEnum = "CONTACT";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
import { FragmentRefs } from "relay-runtime";
export type CrmList_Pagination_Fragment$data = {
  readonly crmLists: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly node: {
            readonly id: string;
            readonly name: string | null | undefined;
            readonly slug: string | null | undefined;
            readonly username: string | null | undefined;
          };
        } | null | undefined;
        readonly content: string | null | undefined;
        readonly created: string | null | undefined;
        readonly id: string;
        readonly status: PostStatusEnum | null | undefined;
        readonly statusSettings: {
          readonly approved: {
            readonly id: string | null | undefined;
            readonly timestamp: string | null | undefined;
            readonly user: {
              readonly name: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly stateWhenApproved: {
            readonly status: PostStatusEnum | null | undefined;
            readonly uiPermission: {
              readonly type: StatusUiPermissionEnum | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly status: PostStatusEnum | null | undefined;
          readonly uiPermission: {
            readonly type: StatusUiPermissionEnum | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly title: string;
        readonly type: CrmListTypeEnum | null | undefined;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "CrmList_Pagination_Fragment";
};
export type CrmList_Pagination_Fragment$key = {
  readonly " $data"?: CrmList_Pagination_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CrmList_Pagination_Fragment">;
};

import CrmLists_Pagination_Query_graphql from './CrmLists_Pagination_Query.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "crmLists"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "where"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": CrmLists_Pagination_Query_graphql
    }
  },
  "name": "CrmList_Pagination_Fragment",
  "selections": [
    {
      "alias": "crmLists",
      "args": [
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "where"
        }
      ],
      "concreteType": "RootQueryToCrmListConnection",
      "kind": "LinkedField",
      "name": "__CrmList_Pagination_Fragment_Connection_crmLists_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RootQueryToCrmListConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CrmList",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusSettings",
                  "kind": "LinkedField",
                  "name": "statusSettings",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StateWhenApproved",
                      "kind": "LinkedField",
                      "name": "stateWhenApproved",
                      "plural": false,
                      "selections": [
                        (v3/*: any*/),
                        (v4/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ApprovedState",
                      "kind": "LinkedField",
                      "name": "approved",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "timestamp",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "User",
                          "kind": "LinkedField",
                          "name": "user",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NodeWizAuthorToUserConnectionEdge",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        (v5/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "username",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "slug",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "created",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RootQueryToCrmListConnectionPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RootQuery",
  "abstractKey": null
};
})();

(node as any).hash = "09236272c516525286df9cb01464dc2b";

export default node;
